module.exports = __webpack_public_path__ + "media/assets/marker-icon-2x-680f69f3.png";